// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".check-block-info[data-v-57e5bad9] .el-dialog{width:var(--common-dialog-large-width)}.check-block-info .el-form[data-v-57e5bad9]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
